import React, { useEffect, useState } from 'react';
import DeleteProductsModal from './DeleteProductsModal';


const ManageAllProducts = () => {
    const [products, setProducts] = useState([]);
    const [reload, setIsReload] = useState(true)
    const [deleteProduct, setDeleteProduct] = useState(null)

    useEffect(() => {
        fetch("https://young-everglades-39818.herokuapp.com/products")
            .then((res) => res.json())
            .then((data) => setProducts(data));
    }, [reload]);

    console.log(deleteProduct)


    return (
        <div id="services" className="my-24 md:mx-12">
            <h2 className="text-3xl font-bold text-center text-primary uppercase"><span className='text-black'>All</span> Products
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 my-12 md:mx-8 gap-4">
                {products.map((product) => (
                    <div className="card md:max-w-full bg-base-200 shadow-xl">
                        <figure className="px-10 pt-10">
                            <img src={product.image} alt="Shoes" className="rounded-md" />
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">{product.name}</h2>
                            <p>{product.description}</p>
                            <small>Available: {product.availableQ}</small>
                            <small>Minimum Order: {product.minimumQ}</small>
                            <p>Unit Price: <span className='text-primary font-bold'>${product.price}</span></p>
                            <div className="card-actions">
                                <label for="my-modal" class="btn btn-primary" onClick={() => setDeleteProduct(product)}>Delete</label>
                            </div>
                        </div>
                        {deleteProduct && <DeleteProductsModal deleteProduct={deleteProduct} reload={reload} setIsReload={setIsReload}></DeleteProductsModal>}
                    </div>

                ))}
            </div>




        </div>
    );
}

export default ManageAllProducts;